import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'
import {i18n} from '~/plugins/i18n'
import Notifications from 'vue-notification'
import LocationPicker from '~/components/LocationPicker/init.js'

import '~/plugins'
import '~/filters'
import '~/components'

Vue.config.productionTip = false

Vue.use(Notifications)
// Vue.use(LocationPicker, {key: 'AIzaSyDfdo4HcUluzig2P_Z7RC8OUJ10OHZuupE'})

new Vue({
  i18n,
  store,
  router,
  ...App
})
